import { InputText } from '@innovyze/stylovyze/lib/components';
import { FormControl } from '@mui/material';
import { useGlobalization } from '../../../contexts';
import { CurveManagerDialogs, CurveType, } from '../../../types/curveManager.types';
import React from 'react';
import { CurveDrawerForm } from './CurveManagerDrawerForm.styles';
import { FieldDropDown } from './components/FieldDropDown';
import { FormLayoutRow, FormLayoutColumn } from './components/FormLayout';
import { SENSOR_TYPE_UNITS_MAP } from '@innovyze/shared-utils';
import { useIsFeatureEnabled } from '../../../utils';
import { useSelectCurveManager } from '@innovyze/stylovyze/lib/selectors';
const getCurveInputName = (t, curveType) => {
    if (curveType === CurveType.PRESSURE_CURVE) {
        return t('Pump Curve Name');
    }
    else if (curveType === CurveType.TANK_CURVE) {
        return t('Tank Curve Name');
    }
    return t('Curve Name');
};
const CurveManagerDrawerForm = ({ curveType, formikProps, }) => {
    const { t } = useGlobalization();
    const isCurveUnitsEnabled = useIsFeatureEnabled('info-360-analytics-manufacture-curve-units');
    const { dialog } = useSelectCurveManager();
    const isEdit = dialog === CurveManagerDialogs.EditCurve;
    const [yAxisType, setYAxisType] = React.useState(formikProps.values.curveData.ySeries?.type ?? 'Pressure');
    const curveTypeOptions = t => [
        { value: 'Pressure', label: t('Pressure') },
        { value: 'Power', label: t('Power') },
        { value: 'Efficiency', label: t('Efficiency') },
    ];
    const typeUnitOptions = t => {
        if (yAxisType === 'Efficiency')
            return [{ value: 'Percent', label: '%' }];
        const options = SENSOR_TYPE_UNITS_MAP[yAxisType]
            ?.filter(unit => unit !== 'No Units')
            ?.filter(unit => unit !== 'm')
            ?.map(unit => ({
            value: unit,
            label: t(unit),
        }));
        return options;
    };
    React.useEffect(() => {
        const unit = typeUnitOptions(t).find(opt => opt.value === formikProps.values.curveData.ySeries?.unit)?.value ??
            typeUnitOptions(t)[0].value ??
            '';
        formikProps.setFieldValue('curveData.ySeries.unit', unit);
    }, [yAxisType]);
    return (React.createElement(CurveDrawerForm, { onSubmit: formikProps.handleSubmit },
        React.createElement(FormControl, { variant: "outlined", margin: "normal", fullWidth: true },
            React.createElement(FormLayoutRow, null,
                React.createElement(InputText, { textField: {
                        required: true,
                        error: !!formikProps?.errors?.curveName,
                        helperText: formikProps?.errors?.curveName,
                        variant: 'outlined',
                        label: getCurveInputName(t, curveType),
                        disabled: isEdit,
                    }, fieldAttrs: {
                        name: 'curveName',
                    } })),
            curveType === CurveType.PRESSURE_CURVE && isCurveUnitsEnabled && (React.createElement(React.Fragment, null,
                React.createElement(FormLayoutRow, null,
                    React.createElement(FormLayoutColumn, null,
                        React.createElement(InputText, { textField: {
                                margin: 'dense',
                                required: true,
                                variant: 'outlined',
                                label: t('X Sensor Type'),
                                disabled: true,
                                value: 'Flow Rate',
                            }, fieldAttrs: {
                                name: 'curveData.xSeries.type',
                            } })),
                    React.createElement(FormLayoutColumn, null,
                        React.createElement(FieldDropDown, { dataCy: "x-field-manufacturerCurve-unit", label: t('X Unit'), name: "curveData.xSeries.unit", options: SENSOR_TYPE_UNITS_MAP['Flow Rate']
                                ?.filter(unit => unit !== 'No Units')
                                ?.map(unit => ({
                                value: unit,
                                label: unit,
                            })), style: { flex: 1 }, required: true, margin: "dense" }))),
                React.createElement(FormLayoutRow, null,
                    React.createElement(FormLayoutColumn, null,
                        React.createElement(FieldDropDown, { dataCy: "field-manufacturerCurve-type", label: t('Y Sensor Type'), name: "curveData.ySeries.type", options: curveTypeOptions(t), onChange: value => {
                                setYAxisType(value?.value ?? '');
                            }, style: { flex: 1 }, required: true })),
                    React.createElement(FormLayoutColumn, null,
                        React.createElement(FieldDropDown, { dataCy: "y-field-manufacturerCurve-unit", label: t('Y Unit'), name: "curveData.ySeries.unit", options: typeUnitOptions(t), style: { flex: 1 }, required: true }))))))));
};
export default CurveManagerDrawerForm;
